import Header from './components/Header'
// import Footer from './components/Footer'
import React, { useEffect, useState } from 'react'
import Widgets from './components/Widgets'
// import Credentials from '../components/Credentials'
// import useAuth from '../lib/hooks/use-auth'
// import ErrorModal from '../components/ErrorModal'
import { useHistory } from 'react-router-dom';
import { Journey } from 'src/common/interfaces/journey.interface';
import { useCurrentOrganization } from 'src/store/organization';
import { Helmet } from 'react-helmet';
import { IconButton } from 'src/common/icon-button';
import { LeftStrongIcon } from 'src/monet/icons';
import { BreadCrumbsComponent } from 'src/common/breadcrumbs/component';
import { apiGetJourney } from 'src/utils/journeyApi';
import useDashboardActiveTab from 'src/dashboard/helpers/active-tab.hook';
import { FixedLoadingSpinner } from 'src/common/components/loading-spinner';
import { useCurrentSubscription } from 'src/store/subscription';
import OrganizationLink from 'src/common/OrganizationLink';

type BreadcrumbsConfig = {
  items: {
    value: string;
    onClick?: () => any;
  }[];
};

type JourneyProps = {
  journeyUuid: string
}
export default function AnalyticsDashboardPage({ journeyUuid }: JourneyProps) {

  useDashboardActiveTab('analytics');

  const { subscriptionLoading,  isSubscribed, isOnTrial, isPro, isEnterprise } = useCurrentSubscription();

  const { currentOrganization } = useCurrentOrganization();
  const [journey, setJourney] = useState<Journey>();
  const [loading, setLoading] = useState(true);

  const history = useHistory()

  const fetchJourney = async () => {
    try {
      setLoading(true);
      setJourney(await apiGetJourney(journeyUuid));
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchJourney();
  }, [journeyUuid]);

  const breadcrumbsConfig: BreadcrumbsConfig = {
    items: [
      {
        value: 'Analytics',
        onClick: () => {
          history.push(`/${currentOrganization.slug}/analytics/journeys`);
        },
      },
      {
        value: 'Journeys',
        onClick: () => {
          history.push(`/${currentOrganization.slug}/analytics/journeys`);
        },
      },
      {
        value: journey?.name || '',
        onClick: () => {
          history.push(`/${currentOrganization.slug}/analytics/journeys/${journey?.uuid}`);
        },
      }
    ],
  };


  return (
    <>
      <Helmet>
        <title>
          Journey | Analytics
        </title>
      </Helmet>
      <div className="analytics-widgets min-h-screen px-5 py-5 text-sm leading-5 bg-body sm:px-10 text-secondary">
        <div className="mx-auto max-w-7xl">
          <div className="space-y-6 sm:space-y-10">

            <>
              <div className=' flex gap-2'>
                <IconButton onClick={() => history.goBack()}>
                  <LeftStrongIcon />
                </IconButton>
                <BreadCrumbsComponent
                  value={breadcrumbsConfig.items[breadcrumbsConfig.items.length - 1].value}
                  items={breadcrumbsConfig.items.map((bci) => bci.value)}
                  itemClassNames={breadcrumbsConfig.items.map((i, index) =>
                    index === breadcrumbsConfig.items.length - 1
                      ? 'max-w-[240px] overflow-hidden whitespace-nowrap text-ellipsis'
                      : ''
                  )}
                  onItemClick={(option, index) => {
                    const bci = breadcrumbsConfig.items[index];
                    bci.onClick && bci.onClick();
                  }}
                />
              </div>

            </>

            {

subscriptionLoading?
<FixedLoadingSpinner />
:
    (!isSubscribed && !isOnTrial) || (isSubscribed && !isEnterprise)?
    <div className='mt-16'>
    <span className='text-neue-journey-medium mb-5'>Upgrade to Scale Plan to access comprehensive analytics</span>
    <img className="mt-3 rounded-md border border-gray-800" src={"https://dashboardcdn.journey.io/dashboard-images/comp-analytics-preview.png"} width={466} height={458} alt={'Comprehensive-Analytics'} />
    <div className='mt-4'>
              <OrganizationLink 
               to={`/billing`}
                className='btn-bedrock-primary'
              >
                Upgrade to Scale Plan
              </OrganizationLink>
            </div>
    </div>
    :
              !journey ?
                loading ?
                  <FixedLoadingSpinner />
                  :
                  <div>Cannot load journey analytics</div>
                :
                <>
                <Header journey={journey}/>
                <main>
                  <Widgets journey={journey} />
                </main>

                </>
            }

          </div>

          <div className="mt-20">
          </div>
          
        </div>
      </div>
    </>
  )
}
